module.exports = __webpack_public_path__ + "img/vipon-logo.77b3ad4a.svg";